import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import MoreIcon from '@/assets/svg/bx-dots-vertical-rounded.svg?react';
import FilterIcon from '@/assets/svg/bx-filter.svg?react';
import MetricSelectorIcon from '@/assets/svg/bx-layout.svg?react';
import { Button } from '@/components/buttons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu';

type Props = {
  onOpenMetricSelector?: () => void;
  onOpenAdvancedFilters?: () => void;
};

const PaidSearchActivityTableActionMenu = ({
  onOpenMetricSelector,
  onOpenAdvancedFilters,
}: Props) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button aria-label={t`More actions`} variant="ghost" size="icon">
            <MoreIcon />
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onOpenAdvancedFilters}>
          <FilterIcon />
          <Trans>Advanced Filters</Trans>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onOpenMetricSelector}>
          <MetricSelectorIcon />
          <Trans>Metrics Selection</Trans>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PaidSearchActivityTableActionMenu;
